//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable'
import * as api from '@/api/api'

import firebase from 'firebase/app'
import 'firebase/storage'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            slide: 0,
            menuId: '',
            restaurantInfo: [],
            menuInfo: [],
            files: [],
            displayLoading: false,
            displayAlert: false,
            alertTitle: '',
            alertMessage: '',
            alertType: '',
            list: '',
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost',
            }
        },
    },
    methods: {
        clear() {
            this.files = []
        },
        removeFromList(order) {
            this.list.forEach((d, index) => {
                if (d.order === order) {
                    this.list.splice(index, 1)
                }
            })
        },
        updateNewOrderList() {
            this.displayLoading = true
            api.updateMenusInformation({
                id: this.menuId,
                Menus: {images: this.list},
            })
                .then(response => {
                    this.displayLoading = false
                    this.alertTitle = 'Exito!'
                    this.alertMessage = 'Se ha subido con exito las imagenes'
                    this.alertType = 'success'
                    this.displayAlert = true
                })
                .catch(error => {
                    this.displayLoading = false
                    this.alertTitle = 'Error'
                    this.alertMessage = error
                    this.alertType = 'error'
                    this.displayAlert = true
                })
        },
        calculatePage(images) {
            let finalArray = []
            let tmp = []
            images.forEach((image, index) => {
                tmp.push(image)
                // console.log(`index: ${index} tiene ${JSON.stringify(tmp)}`)
                if (((index + 1) / 3) % 1 === 0) {
                    finalArray.push(tmp)
                    tmp = []
                }
            })
            if (tmp.length > 0) finalArray.push(tmp)
            if (finalArray.length === 0) finalArray.push([1, 2, 3])
            return finalArray
        },
        async uploadMenus() {
            this.displayLoading = true
            let listOfUploadedFiles = this.menuInfo.images
            let db = firebase.firestore()
            for (const file of this.files) {
                await this.uploadToFirebase(
                    file,
                    `menus/${this.restaurantInfo.restaurantName}`,
                    file.name
                )
                    .then(filename => {
                        listOfUploadedFiles.push({
                            url: filename,
                            name: file.name,
                        })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            api.updateMenusInformation({
                id: this.menuId,
                Menus: {images: listOfUploadedFiles},
            })
                .then(response => {
                    this.displayLoading = false
                    this.alertTitle = 'Exito!'
                    this.alertMessage = 'Se ha subido con exito las imagenes'
                    this.alertType = 'success'
                    this.displayAlert = true
                    this.clear()
                })
                .catch(error => {
                    this.displayLoading = false
                    this.alertTitle = 'Error'
                    this.alertMessage = error
                    this.alertType = 'error'
                    this.displayAlert = true
                })
        },
        uploadToFirebase(imageFile, fullDirectory, filename) {
            return new Promise(function (resolve, reject) {
                var storageRef = firebase
                    .storage()
                    .ref(fullDirectory + '/' + filename)
                //Upload file
                var task = storageRef.put(imageFile)
                //Update progress bar
                task.on(
                    'state_changed',
                    function (snapshot) {
                        // Observe state change events such as progress, pause, and resume
                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                        var progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100
                        console.log('Upload is ' + progress + '% done')
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused')
                                break
                        }
                    },
                    function (error) {
                        // Handle unsuccessful uploads
                        console.log(`Error in uploadToFirebase: ${error}`)
                        reject(error)
                    },
                    function () {
                        // Handle successful uploads on complete
                        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                        task.snapshot.ref
                            .getDownloadURL()
                            .then(function (downloadURL) {
                                console.log('File available at', downloadURL)
                                resolve(downloadURL)
                            })
                    }
                )
            })
        },
        addToData(id, data) {
            data.id = id
            this.menuInfo = data
        },
    },
    async mounted() {
        this.menuId = this.$route.params.id
        let db = firebase.firestore()
        await db
            .collection('Menus')
            .doc(this.menuId)
            .onSnapshot(
                {
                    includeMetadataChanges: true,
                },
                doc => {
                    api.returnRestaurantById({
                        id: doc.data().restaurant,
                    }).then(response => {
                        this.restaurantInfo = response.data.data
                    })
                    this.addToData(doc.id, doc.data())
                    this.list = this.menuInfo.images.map((name, index) => {
                        return {
                            name: name.name,
                            order: index + 1,
                            url: name.url,
                        }
                    })
                }
            )
    },
}
